module.exports = __webpack_public_path__ + "static/media/vs-min.8d118651.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/vs-min.svg
// module id = 680
// module chunks = 0